module.exports = __webpack_public_path__ + "static/media/A1-3-Syderia-cod85.5c515d46.png";